import React, {lazy, Suspense} from 'react';

const TheTimeAgo = lazy(() => import(/* webpackPreload: true, webpackChunkName: "ui-components" */'./TheTimeAgo'));

const TimeAgo = (props) => {
    return <Suspense fallback={null}>
        <TheTimeAgo {...props} />
    </Suspense>
}

export default TimeAgo;